import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../components/Header";
import config from "../config";
import "../App.css";

const API = `${config.API_BASE_URL}/api/gallery`;

function Gallery() {
const [photos, setPhotos] = useState([]);
const [category, setCategory] = useState("All");
const [selected, setSelected] = useState(null);
const [loading, setLoading] = useState(true);

useEffect(() => {
loadPhotos();
}, []);

const loadPhotos = async () => {
try {
setLoading(true);

 
  const res = await axios.get(API);

  setPhotos(res.data.data || []);
} catch (err) {
  console.error("Gallery Error:", err);
} finally {
  setLoading(false);
}
 

};

const categories = [
"All",
...new Set(
photos
.map((p) => p.category || p.Category)
.filter(Boolean)
),
];

const filteredPhotos =
category === "All"
? photos
: photos.filter(
(p) =>
(p.category || p.Category) === category
);

return ( <div className="home-page"> <Header />
 
  <section className="gallery-hero">
    <div className="gallery-hero-card">
      <h1 className="gallery-title">
        📸 Spiritual Gallery
      </h1>

      <p className="gallery-subtitle">
        Divine moments, gemstones,
        astrology consultations,
        spiritual journeys and memories.
      </p>
    </div>
  </section>

  <div className="gallery-filters">
    {categories.map((cat) => (
      <button
        key={cat}
        onClick={() => setCategory(cat)}
        className={
          category === cat
            ? "gallery-filter active"
            : "gallery-filter"
        }
      >
        {cat}
      </button>
    ))}
  </div>

  {loading ? (
    <div className="gallery-loading">
      Loading Gallery...
    </div>
  ) : filteredPhotos.length === 0 ? (
    <div className="gallery-empty">
      No photos available.
    </div>
  ) : (
    <div className="gallery-grid-public">
      {filteredPhotos.map((photo) => {
        const image =
          photo.image || photo.Image;

        const title =
          photo.title ||
          photo.Title ||
          "Gallery Photo";

        return (
          <div
            key={
              photo.id ||
              photo.Id
            }
            className="gallery-public-card"
            onClick={() =>
              setSelected(photo)
            }
          >
            <img
              src={`${config.API_BASE_URL}/uploads/${image}`}
              alt={title}
              className="gallery-public-image"
            />

            <div className="gallery-public-overlay">
              <h3>{title}</h3>
            </div>
          </div>
        );
      })}
    </div>
  )}

  {selected && (
    <div
      className="gallery-lightbox"
      onClick={() =>
        setSelected(null)
      }
    >
      <div
        className="gallery-lightbox-content"
        onClick={(e) =>
          e.stopPropagation()
        }
      >
        <button
          className="gallery-close"
          onClick={() =>
            setSelected(null)
          }
        >
          ✕
        </button>

        <img
          src={`${config.API_BASE_URL}/uploads/${
            selected.image ||
            selected.Image
          }`}
          alt={
            selected.title ||
            selected.Title ||
            ""
          }
          className="gallery-lightbox-image"
        />

        <h3>
          {selected.title ||
            selected.Title}
        </h3>
      </div>
    </div>
  )}
</div>
 
);
}

export default Gallery;
